import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _get from 'lodash/get';
import _noop from 'lodash/noop';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts';

import CopyInput from './CopyInput';

const Title = styled.label`
    margin-bottom: 5px;
    color: ${COLORS.mlbGrey3};
    font-family: ${FONTS.primaryFont};
    font-size: 10px;
    line-height: 1.6;
    text-transform: uppercase;
`;

const Url = ({
    link,
    dictionary,
    onShare,
    mediaPlayback,
}) => {

    const label = _get(dictionary, 'share_url_text', 'Share Url');

    return (
        <>
            <Title>{label}</Title>
            <CopyInput
                name={'Link'}
                value={link}
                iconType={'link'}
                ariaLabel={label}
                dictionary={dictionary}
                onClick={onShare}
                mediaPlayback={mediaPlayback}
            />
        </>
    );

};

Url.propTypes = {
    link: PropTypes.string,
    dictionary: PropTypes.object,
    onShare: PropTypes.func,
    mediaPlayback: PropTypes.object,
};

Url.defaultProps = {
    link: 'https://www.mlb.com',
    dictionary: {},
    onShare: _noop,
    mediaPlayback: {},
};

export default Url;
